import { CART_CHANGE_TYPE, CART_PAGE_STATUS } from "../../constants/status";
import { GetAddressParamModel } from "../../model/address";
import {
  CreateCartParams,
  GetCartParamsModel,
  SavedCartParamsModel,
} from "../../model/cart";
import { HeaderParamsModel } from "../../model/common";
import { getAddressPriceRuleAsync } from "../../reducers/addressPriceRule";
import { createCart, getCartAsync } from "../../reducers/cart";
import { getItemsByAddressAndDateAsync } from "../../reducers/item";
import {
  getSavedCartAsync,
  saveSavedCartAsync,
} from "../../reducers/savedcart";
import { updateStatus } from "../../reducers/status";

export const getCartInfo = async (
  dispatch: any,
  headerProps: HeaderParamsModel,
  getCartProps: GetCartParamsModel
) => {
  return await dispatch(
    getCartAsync({ headerParams: headerProps, getCartParams: getCartProps })
  );
};

export const createNewCart = async (
  dispatch: any,
  cartProps: CreateCartParams,
  headerProps: HeaderParamsModel,
  getCartProps: GetCartParamsModel,
  getDeliveryRulesProps: GetAddressParamModel
) => {
  dispatch(createCart(cartProps));
  dispatch(getItemsByAddressAndDateAsync(headerProps));
  getCartInfo(dispatch, headerProps, getCartProps);
  dispatch(getSavedCartAsync(headerProps));
  dispatch(getAddressPriceRuleAsync(getDeliveryRulesProps));

  return await dispatch(updateStatus(CART_PAGE_STATUS.INITIAL));
};

export const getCartByParams = async (
  dispatch: any,
  headerProps: HeaderParamsModel,
  getCartProps: GetCartParamsModel,
  getDeliveryRulesProps: GetAddressParamModel,
  changeType: number
) => {
  dispatch(getItemsByAddressAndDateAsync(headerProps));
  dispatch(getSavedCartAsync(headerProps));
  if (changeType === CART_CHANGE_TYPE.ADDRESS)
    dispatch(getAddressPriceRuleAsync(getDeliveryRulesProps));

  await dispatch(
    getCartAsync({ headerParams: headerProps, getCartParams: getCartProps })
  );
  return await dispatch(updateStatus(CART_PAGE_STATUS.INITIAL));
};

export const saveSavedCart = async (
  dispatch: any,
  savedCartParams: SavedCartParamsModel
) => {
  await dispatch(saveSavedCartAsync(savedCartParams));
  return await dispatch(updateStatus(CART_PAGE_STATUS.INITIAL));
};
